import React from "react";
import {MetadataState} from "./types";

type MetadataReducerAction =
    { type: 'SET_IS_INITIAL_COMPLAINT', payload: boolean }

export const setIsInitialComplaint = (isInitialComplaint: boolean): MetadataReducerAction => ({
    type: 'SET_IS_INITIAL_COMPLAINT',
    payload: isInitialComplaint
})

const MetadataReducer: React.Reducer<MetadataState, MetadataReducerAction> = (state, action) => {
    switch (action.type) {
        case 'SET_IS_INITIAL_COMPLAINT':
            return {...state, metadata: {isInitialComplaint: action.payload}}
        default:
            return state
    }
}

export default MetadataReducer
